"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Heading from "./webflow_modules/Basic/components/Heading";
import Image from "./webflow_modules/Basic/components/Image";
import Link from "./webflow_modules/Basic/components/Link";
import List from "./webflow_modules/Basic/components/List";
import ListItem from "./webflow_modules/Basic/components/ListItem";
import Paragraph from "./webflow_modules/Basic/components/Paragraph";
import RichText from "./webflow_modules/Basic/components/RichText";
import Section from "./webflow_modules/Layout/components/Section";
import Span from "./webflow_modules/Basic/components/Span";
import Strong from "./webflow_modules/Basic/components/Strong";
import * as _interactions from "./webflow_modules/interactions";
import { Footer } from "./Footer";
import { Gallery } from "./Gallery";
import { GlobalStyles } from "./GlobalStyles";
import { HeroSubCardComponentContainer } from "./HeroSubCardComponentContainer";
import { Navbar } from "./Navbar";

const _interactionsData = JSON.parse(
  '{"events":{"e-31":{"id":"e-31","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-32"}},"mediaQueries":["main"],"target":{"selector":".navbar_interaction-trigger","originalId":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"CLASS"},"targets":[{"id":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1702402485163},"e-32":{"id":"e-32","name":"","animationType":"custom","eventTypeId":"SCROLL_OUT_OF_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-16","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-31"}},"mediaQueries":["main"],"target":{"selector":".navbar_interaction-trigger","originalId":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"CLASS"},"targets":[{"id":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1702402485163},"e-133":{"id":"e-133","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-59","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-134"}},"mediaQueries":["main"],"target":{"id":"531afea1-f7ee-a46f-faa0-d874a3f6cfbf","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"531afea1-f7ee-a46f-faa0-d874a3f6cfbf","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1707941876221},"e-134":{"id":"e-134","name":"","animationType":"preset","eventTypeId":"SCROLL_OUT_OF_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-60","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-133"}},"mediaQueries":["main"],"target":{"id":"531afea1-f7ee-a46f-faa0-d874a3f6cfbf","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"531afea1-f7ee-a46f-faa0-d874a3f6cfbf","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1707941876221}},"actionLists":{"a-15":{"id":"a-15","title":"Navbar [transparent]","actionItemGroups":[{"actionItems":[{"id":"a-15-n","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":0}}]},{"actionItems":[{"id":"a-15-n-2","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":0}}]}],"useFirstGroupAsInitialState":true,"createdOn":1702402503174},"a-16":{"id":"a-16","title":"Navbar [solid]","actionItemGroups":[{"actionItems":[{"id":"a-16-n-2","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":1}}]}],"useFirstGroupAsInitialState":false,"createdOn":1702402503174},"a-59":{"id":"a-59","title":"Navbar [transparent] 5","actionItemGroups":[{"actionItems":[{"id":"a-59-n","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":0}}]},{"actionItems":[{"id":"a-59-n-2","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":0}}]}],"useFirstGroupAsInitialState":true,"createdOn":1702402503174},"a-60":{"id":"a-60","title":"Navbar [solid] 5","actionItemGroups":[{"actionItems":[{"id":"a-60-n","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":1}}]}],"useFirstGroupAsInitialState":false,"createdOn":1702402503174}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function PageComponentDisclosuresAndLicenses({}) {
  _interactions.useInteractions(_interactionsData);

  return (
    <Block tag={"div"}>
      <GlobalStyles />
      <Block className={"page-wrapper"} tag={"div"}>
        <Block
          className={"navbar_interaction-trigger"}
          data-w-id={"531afea1-f7ee-a46f-faa0-d874a3f6cfbf"}
          tag={"div"}
        />
        <Navbar />
        <Block className={"main-wrapper"} tag={"main"}>
          <Block className={"header"} tag={"header"}>
            <Block className={"padding-global"} tag={"div"}>
              <Block className={"container-small"} tag={"div"}>
                <Block className={"header30_content"} tag={"div"}>
                  <Block className={"padding-section-large"} tag={"div"}>
                    <Block className={"text-align-center"} tag={"div"}>
                      <Heading className={"text-color-white"} tag={"h1"}>
                        <Strong>{"Disclosures and Licenses"}</Strong>
                      </Heading>
                    </Block>
                  </Block>
                </Block>
              </Block>
            </Block>
            <Block className={"header30_background-image-wrapper"} tag={"div"}>
              <Block className={"image-overlay-layer"} tag={"div"} />
              <Image
                alt={""}
                className={"header30_background-image"}
                height={"auto"}
                loading={"eager"}
                src={
                  "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657cc1e87bc911eb83bd6937_Rectangle%20100.jpg"
                }
                width={"auto"}
              />
            </Block>
          </Block>
          <Section className={"map"} tag={"section"}>
            <Block className={"padding-global"} tag={"div"}>
              <Block className={"container-large"} tag={"div"}>
                <Block className={"padding-section-large-update"} tag={"div"}>
                  <RichText
                    className={"trb-pricacy"}
                    tag={"div"}
                    target={"_blank"}
                  >
                    <Heading tag={"h1"}>{"Disclosures and Licenses"}</Heading>
                    <Paragraph>{"‍"}</Paragraph>
                    <Paragraph>{"‍"}</Paragraph>
                    <Heading tag={"h2"}>{"Nevada"}</Heading>
                    <List tag={"ul"} unstyled={false}>
                      <ListItem>{"LLC: SRG Nevada, LLC"}</ListItem>
                      <ListItem>{"Broker License #: B.1002556.CORP"}</ListItem>
                    </List>
                    <Heading tag={"h2"}>{"Texas"}</Heading>
                    <List tag={"ul"} unstyled={false}>
                      <ListItem>{"LLC: SRG Texas, LLC. "}</ListItem>
                      <ListItem>{"Broker License #: 9011380"}</ListItem>
                      <ListItem>
                        <Link
                          button={false}
                          options={{
                            href: "https://assets-global.website-files.com/5c54ca7eb707442cf1c08f69/6361a32c16f9c4781d49b00b_TX%20CPN%201-4-1_1.pdf",
                          }}
                        >
                          {"TX REC Consumer Protection Notice"}
                        </Link>
                      </ListItem>
                      <ListItem>
                        <Link
                          button={false}
                          className={"style"}
                          options={{
                            href: "https://cdn.lineups.io/477d28a3-0dbc-483f-a788-9e5e08c66bd7/",
                            target: "_blank",
                          }}
                        >
                          {"TX Information About Brokerage Services"}
                        </Link>
                      </ListItem>
                    </List>
                    <Heading tag={"h2"}>{"Oklahoma"}</Heading>
                    <List tag={"ul"} unstyled={false}>
                      <ListItem>
                        {
                          "LLC: SRG Texas, LLC dba SRG Residential; Broker Company"
                        }
                      </ListItem>
                    </List>
                    <Paragraph>{"‍"}</Paragraph>
                  </RichText>
                </Block>
              </Block>
            </Block>
          </Section>
          <Section className={"current-residents"} tag={"section"}>
            <Block className={"padding-global"} tag={"div"}>
              <Block className={"container-large"} tag={"div"} />
            </Block>
          </Section>
          <HeroSubCardComponentContainer />
          <Section
            className={"difference_component background-color-grey"}
            tag={"section"}
          >
            <Block className={"padding-global mobile-none"} tag={"div"}>
              <Block className={"container-large"} tag={"div"}>
                <Block tag={"div"}>
                  <Block className={"mobile-padding-global"} tag={"div"}>
                    <Block className={"communities_header"} tag={"div"}>
                      <Block
                        className={"difference_heading-wrapper"}
                        tag={"div"}
                      >
                        <Heading tag={"h2"}>
                          {"THE SRG "}
                          <Span className={"text-color-blue"}>
                            {"Difference"}
                          </Span>
                        </Heading>
                      </Block>
                      <Block
                        className={"decoration-line is-black"}
                        tag={"wrapper"}
                      />
                    </Block>
                  </Block>
                  <Block className={"div-block-34"} tag={"div"}>
                    <Block className={"mobile-padding-global"} tag={"div"}>
                      <Block className={"max-width-medium"} tag={"div"}>
                        <Paragraph className={"text-size-medium"}>
                          {
                            "At SRG Residential, we take utmost pride in being a reliable support system for our residents and employees, fostering strong and vibrant communities where everyone feels valued and cared for. We understand the importance of loving where you live and that's why we are committed to providing hassle-free living experiences."
                          }
                        </Paragraph>
                      </Block>
                    </Block>
                    <Block className={"stats-background is-grey"} tag={"div"}>
                      <Block tag={"div"}>
                        <Block
                          className={"heading-style-h6 text-color-black"}
                          tag={"div"}
                        >
                          {"Locations"}
                        </Block>
                        <Block
                          className={"heading-style-h1 text-color-blue"}
                          tag={"div"}
                        >
                          {"150+"}
                        </Block>
                      </Block>
                      <Block tag={"div"}>
                        <Block
                          className={"heading-style-h6 text-color-black"}
                          tag={"div"}
                        >
                          {"Founded"}
                        </Block>
                        <Block
                          className={"heading-style-h1 text-color-blue"}
                          tag={"div"}
                        >
                          {"1993"}
                        </Block>
                      </Block>
                    </Block>
                  </Block>
                </Block>
              </Block>
            </Block>
          </Section>
          <Gallery />
        </Block>
        <Footer />
      </Block>
    </Block>
  );
}
